import React from 'react';
import { motion } from 'framer-motion';
export function ThreeSteps() {
  const steps = [{
    num: '01',
    title: 'Claim Your Offer',
    desc: 'Fill out the short form on this page to lock in your $3,000 discount.'
  }, {
    num: '02',
    title: 'We Call You',
    desc: 'Our friendly team will call you within 5 minutes to answer questions and find a time that works for you.'
  }, {
    num: '03',
    title: 'Visit Us',
    desc: 'Come in for your free Invisalign consultation and see what your new smile could look like.'
  }];
  return <section className="py-10 lg:py-20 bg-white" data-id="element-188">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-189">
        <div className="text-center mb-8 lg:mb-16" data-id="element-190">
          <h2 className="text-3xl md:text-4xl font-light text-brand-dark mb-3 lg:mb-4" data-id="element-191">
            Getting Started Is Easy
          </h2>
          <p className="text-lg text-brand-dark/60" data-id="element-192">
            Three simple steps to your new confident smile.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8 relative" data-id="element-193">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 bg-brand-dark/10 -z-10" data-id="element-194"></div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="flex flex-col items-center text-center relative bg-white" data-id="element-195">
              <div className="w-16 h-16 lg:w-24 lg:h-24 bg-brand-dark rounded-full flex items-center justify-center mb-3 lg:mb-6 border-4 border-white" data-id="element-196">
                <span className="text-xl lg:text-2xl font-light text-white" data-id="element-197">
                  {step.num}
                </span>
              </div>
              <h3 className="text-lg lg:text-xl font-medium text-brand-dark mb-2 lg:mb-3" data-id="element-198">
                {step.title}
              </h3>
              <p className="text-sm lg:text-base text-brand-dark/60 max-w-xs" data-id="element-199">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}